import { TeamMemberUserInfo } from "@faire/retailer-visitor-shared/components/TeamMemberUserInfo";
import { Column, Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { IGetInvitedUserResponse } from "@faire/web-api--source/indigofair/data/IGetInvitedUserResponse";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import React from "react";

interface IProps {
  hideTitle?: boolean;
  subUserInvite: IGetInvitedUserResponse;
}

export const SubUserWelcome: React.FC<IProps> = ({
  subUserInvite,
  hideTitle,
}) => {
  return (
    <Column>
      {hideTitle ? null : (
        <>
          <Typography align="center" variant="pageHeaderSerifRegular">
            <StrictLocalMsg
              defaultMessage="Join your team!"
              description={{
                text: "Header to welcome new potential sub user.",
                img: "https://cdn.faire.com/fastly/b834a9e409f7b9508529765ec3bf098965d5720962b87084b4928f4d9febcb3f.png",
              }}
            />
          </Typography>
          <Spacer size="3x" />
        </>
      )}
      <Row align="flex-start" gap="2x">
        {(subUserInvite.team_introduction_information ?? []).map(
          (teamInfo, index) => {
            return (
              <TeamMemberUserInfo
                key={index}
                images={teamInfo.profile_image_urls.map((url) =>
                  IImage.build({ url })
                )}
                title={teamInfo.title ?? ""}
                subtitle={teamInfo.subtitle ?? ""}
              />
            );
          }
        )}
      </Row>
    </Column>
  );
};
